export const openWindow = (url: string): Window | null => window.open(url, "_blank", "noopener,noreferrer,resizable");
